import axios from 'axios';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: defaultHeaders,
});

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_PUBLIC_URL,
  headers: defaultHeaders,
});
